(function () {
  'use strict';
  var url = new URL(window.location.href);
  var dialog = document.querySelector('[data-scan-return]');
  if (url.searchParams.get('scan') !== 'thank-you' || !dialog || typeof dialog.showModal !== 'function') return;
  var previousFocus = document.activeElement;
  dialog.showModal();
  document.documentElement.classList.add('scan-return-open');
  // Consume only our marker. Preserve all other query values and the hash.
  url.searchParams.delete('scan');
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  function close() { dialog.close(); }
  dialog.querySelectorAll('[data-scan-return-close]').forEach(function (button) { button.addEventListener('click', close); });
  dialog.addEventListener('click', function (event) {
    var rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
  });
  dialog.addEventListener('close', function () {
    document.documentElement.classList.remove('scan-return-open');
    if (previousFocus && previousFocus !== document.body) previousFocus.focus();
    else { var home = document.querySelector('a[aria-label="Fore2Feet home"]'); if (home) home.focus(); }
  });
})();
